Vue.asyncComponent('ak-confirm-unsaved-changes', {
    data() {
        return {
            ignoreConfirmCheck: false,
            showConfirm: false,
            confirmRoute: null,
        }
    },
    computed: {
        confirmMessage() {
            return this.$confirmUnsavedChangesHandler.getConfirmMessage() ?
                    this.$confirmUnsavedChangesHandler.getConfirmMessage() :
                    this.$t('Ben je zeker dat je wilt verdergaan zonder te bewaren? De wijzigingen die je hebt gedaan, zullen verloren gaan.');
        }
    },
    methods: {
        /**
         * Check if we can do a location change
         * @param event
         * @returns {Promise<void>}
         */
        checkConfirmLocationChange(event) {
            const result = this.checkShowConfirm();

            // For a route change we need to use de default dialog so we show the message there
            if (result) {
                event.returnValue = this.confirmMessage;
                return this.confirmMessage;
            }
        },
        /**
         * Check if we can do a route change
         * @param to
         * @param from
         * @param next
         * @returns {Promise<void>}
         */
        checkConfirmRouteChange(to, from, next) {
            this.confirmRoute = to;
            this.showConfirm = this.checkShowConfirm(to,from,next);

            if(this.showConfirm) {
                if(confirm(this.confirmMessage)) {
                    this.confirmRouteChange();
                } else {
                    next(false);
                }
            } else {
                next();
            }
        },
        /**
         * Check confirm handler
         * Before each route change we check if we have a showConfirmCallback
         * If so we run it
         * If we need to show cofirmation we prevent a route change and only apply it if the user consensts to it
         * @param to
         * @param from
         * @param next
         * @returns {Promise<void>}
         */
         checkShowConfirm(to, from, next) {
            // Check if we need to ignore this check
            // this is necassary for the confirmDialog action to work
            if(this.ignoreConfirmCheck) {
                this.ignoreConfirmCheck = false;
                return false;
            }

            // Check if we have callback
            const callback = this.$confirmUnsavedChangesHandler.getShowConfirmCallback();
            if(! callback) {
                return false;
            }

            // check if we need to show the confirm modal
            return callback(to,from,next);
        },
        /**
         * Confirm route change
         */
        confirmRouteChange() {
            // make sure we ignore the check
            this.ignoreConfirmCheck = true;
            // hide the modal
            this.showConfirm = false;

            // reset the confirm handler
            this.$confirmUnsavedChangesHandler.setShowConfirmCallback(null);
            this.$confirmUnsavedChangesHandler.setConfirmMessage(null);

            // go to the original route
            if (this.$router) {
                this.$router.push(this.confirmRoute);
            }
        },
        tabChanged() {
            if (this.checkShowConfirm() && document.visibilityState != "visible") {
                document.title = '⚠ ' + document.title;
            } else {
                document.title = document.title.replace('⚠ ', '');
            }
        }
    },
    created() {
        if (this.$router) {
            this.$router.beforeResolve(this.checkConfirmRouteChange);
        }
    },
    beforeMount() {
        document.addEventListener("visibilitychange", this.tabChanged);
        window.addEventListener("beforeunload", this.checkConfirmLocationChange);
    },
    beforeDestroy() {
        document.removeEventListener("visibilitychange", this.tabChanged);
        window.removeEventListener("beforeunload", this.checkConfirmLocationChange);
    }
}, 'utilities/ak-confirm-unsaved-changes.html');